(function () {
    'use strict';

    angular
      .module('crewBaseAssignmentReport')
      .config(config);

    function config($stateProvider) {
        $stateProvider
          .state('crewBaseAssignmentReport', {
              url: '/crew-base-assignment-report',
              views : {
                  'crewBaseAssignmentReportView' : {
                      templateUrl: 'crew-base-assignment-report/views/crew-base-assignment-report.tpl.html',
                      controller: 'CrewBaseAssignmentReportCtrl',
                      controllerAs: 'crewBaseAssignmentReport'
                  }
              }
          });
    }
}());
